const BASE_URL = 'https://style.maps.atrius.com';

export const StyleLoader = {
    getStyle: async (vertical, venueId) =>
        fetch(`${BASE_URL}/v1/vertical/${vertical}/venue/${venueId}`)
            .then(response => response.json())
            .then(data => data.data),
};
